export default function onlyDigits() {
  'ngInject';

  return {
    require: 'ngModel',
    link($scope, $element, $attrs, $ctrl) {
      $ctrl.$parsers.push((value) => {
        if (value) {
          let transformedValue = value.replace(/[^0-9]/g, '');

          if ($attrs.onlyDigits) {
            const limit = Number($attrs.onlyDigits);
            if (!isNaN(limit) && transformedValue.length > limit) {
              transformedValue = transformedValue.substring(0, 4);
            }
          }

          if (transformedValue !== value) {
            $ctrl.$setViewValue(transformedValue);
            $ctrl.$render();
          }
          return transformedValue;
        }
        return null;
      });
    },
  };
}
